import { ReactNode } from "react";
import { Stack, Typography } from "@mui/material";

export const TitleBlock = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  return (
    <Stack gap={"12px"}>
      <Typography
        component="h5"
        sx={{
          color: "#024760",
          fontSize: "18px",
          fontWeight: 600,
          lineHeight: "22px",
        }}
      >
        {title}
      </Typography>
      {children}
    </Stack>
  );
};
